@switch (step) {
  @case (Step.Environment) {
    <ng-casto-closet-doors-standard-preview-environment />
  }
  @case (Step.DoorConfiguration) {
    <ng-casto-closet-doors-standard-preview-door-configuration />
  }
  @case (Step.Range) {
    <ng-casto-closet-doors-standard-preview-range />
  }
  @case (Step.Finishes) {
    <ng-casto-closet-doors-standard-preview-finishes
      [finishesStep]="finishesStep"
      [finishesRendered]="finishesRendered" />
  }
  @case (Step.Summary) {
    <ng-casto-closet-doors-standard-preview-summary />
  }
}
